export class Relay {
  id: number;
  name: string;
  enabled: boolean;
  relayBoardId: number;
  relayId: number;
  description: string;

  public constructor(init?: Partial<Relay>) {
    Object.assign(this, init);
  }
}
